module.exports = __webpack_public_path__ + "img/bread-easypay.8937e2df.png";